// extracted by mini-css-extract-plugin
export default {"data_table_anchored_cell":"I8HjiCkKGZysd6yAbe4axg==","data_table_anchor":"IXjYJXXcF+kvs2cUxltIbw==","linkable_cell_content":"rrCuwBw6ZDpt+k35sUoYTw=="};